export default __webpack_public_path__ + "static/media/quesoDanbo.645678b3.png";